import { images } from "@/data/images";

// Unified content feed — the growth engine of the ecosystem.
// Add Articles, Coaching Journals, Film Breakdowns and Leadership Lessons here over time;
// the Journal hub filters, searches, sorts and paginates them automatically.
export const journalCategories = "auto"; // categories derived from items via useCollection

export const journalEntries = [
  {
    id: "j1",
    type: "Article",
    category: "Culture",
    title: "Why Culture Beats Talent — Every Time",
    excerpt:
      "Shared standards and daily accountability turn a group of players into a connected team. A look at how culture compounds over a season.",
    body: [
      "Talent sets a ceiling. Culture decides whether you reach it. The programs that last are built on standards that every player is held to — every single day.",
      "When the standard is clear and the relationships are strong, talent compounds. When the standard is fuzzy, even great talent underachieves. Culture is the multiplier.",
      "This is why we invest in culture first: it's the foundation that everything else — development, strategy, winning — is built on.",
    ],
    date: "Coming Soon",
    readTime: "5 min read",
    thumbnail: images.ballFloor,
    featured: true,
    order: 12,
    status: "coming-soon",
  },
  {
    id: "j2",
    type: "Film Breakdown",
    category: "Tactics",
    title: "Reading the Spain Pick & Roll",
    excerpt:
      "How layered ball-screen actions create advantages against any coverage — and how we teach the reads to young players.",
    body: [
      "The Spain (stack) ball screen layers a back-screen onto a standard pick-and-roll, forcing multiple defenders to make decisions at once.",
      "We teach it in three reads: the screener's dive, the back-screener's lift, and the ball handler's downhill attack. Master the timing and the advantage appears.",
    ],
    date: "Coming Soon",
    readTime: "7 min read",
    thumbnail: images.dunkDark,
    featured: true,
    order: 11,
    status: "coming-soon",
  },
  {
    id: "j3",
    type: "Coaching Journal",
    category: "Reflection",
    title: "Notes From a Hard Practice",
    excerpt:
      "An honest reflection on a tough day in the gym — what broke down, what we learned, and how we responded the next morning.",
    body: [
      "Some of the best growth happens on the days that feel like failures. Today was one of those days.",
      "We were flat, disconnected, and careless with the basketball. But how a team responds to a hard practice tells you everything about its character.",
    ],
    date: "Coming Soon",
    readTime: "4 min read",
    thumbnail: images.practicePlayers,
    featured: false,
    order: 10,
    status: "coming-soon",
  },
  {
    id: "j4",
    type: "Leadership Lesson",
    category: "Leadership",
    title: "The Word of the Day: Accountability",
    excerpt:
      "Owning your actions, your effort, and your role in the outcome — no excuses. Why accountability is the currency of trust.",
    body: [
      "Accountability builds trust. Teammates rely on the players who own their job, every possession, without pointing fingers.",
      "We practice it daily: admit the mistake, fix the mistake, move on. That's how a locker room learns to trust each other.",
    ],
    date: "Coming Soon",
    readTime: "3 min read",
    thumbnail: images.coachSideline,
    featured: false,
    order: 9,
    status: "coming-soon",
  },
  {
    id: "j5",
    type: "Article",
    category: "Development",
    title: "The Long Game of Player Development",
    excerpt:
      "Why patience, process, and daily habits beat hype when developing real athletes who keep growing for years.",
    body: [
      "Development isn't linear and it isn't fast. The athletes who win the long game are the ones who fall in love with the daily process.",
      "We measure progress in habits, not highlights. Get a little better today than you were yesterday — and let it compound.",
    ],
    date: "Coming Soon",
    readTime: "6 min read",
    thumbnail: images.arenaDark,
    featured: false,
    order: 8,
    status: "coming-soon",
  },
  {
    id: "j6",
    type: "Film Breakdown",
    category: "Defense",
    title: "Building the Wall in Transition",
    excerpt:
      "How disciplined teams protect the paint first and take away early offense — broken down from FIBA film.",
    body: [
      "Transition defense is effort plus organization. Sprint to protect the paint, stop the ball, build the wall, then match up.",
      "Protecting the rim first prevents the easiest points in basketball. It's a habit we build every practice.",
    ],
    date: "Coming Soon",
    readTime: "5 min read",
    thumbnail: images.dunkDark,
    featured: false,
    order: 7,
    status: "coming-soon",
  },
];
